<template>
  <div class="conteudoInterno" id="numeros2025">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState,
      }">
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>UBC Distribution Figures in 2025</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcRedBack"></span>
        </div>
        <div class="col49 top32">

          <p>Here we focus on UBC’s figures, which are the direct result of our efforts in documentation, the clearance
            of previously unidentified performances, services provided to members, and internal processes for
            distributing royalties received from abroad, as well as mechanical rights. This also includes, of course,
            our share of performance data within the national territory, as detailed earlier.</p>
          <p>UBC accounted for 62% of all distributions made by the collective of societies that make up ECAD.</p>


        </div>
      </section>
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcRedBack"></div>
        <div class="col49">
          <div class="col100">
            <h4 class="h4Destaque ubcRed sanukBlack">
              UBC Distribution Figures
            </h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <h3>Public performance rights (collected in Brazil)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">BRL 987,822,510</span>
              </div>

            </div>
            <div class="col49sub topMob32">
              <h3>Public performance rights (collected abroad)</h3>
              <div class="numerosBox">

                <span class="ubcRed sanukBlack">BRL 12,893,997</span>
              </div>

            </div>
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <h3>Mechanical rights (domestic)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">BRL 5,146,694</span>
              </div>
            </div>
            <div class="col49sub topMob32">
              <h3>Mechanical rights (international)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">BRL 44,408</span>
              </div>
            </div>
          </div>

          <div class="col100 top80">
            <h3>
              Number of rightsholders receiving distributions:
            </h3>
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <span class="titleDireitos sanukBold">Foreign</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">206,174</span>
              </div>

            </div>
            <div class="col49sub topMob32">
              <span class="titleDireitos sanukBold">Domestic</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">32,809</span>
              </div>

            </div>
          </div>
          <div class="col100 top50 boxend">
            <div>
              <p>
                Released withheld rights: <span class="ubcRed sanukBlack">BRL 128,956,033.50</span>
              </p>
            </div>
            <div>
              <p>
                # Registered works:
                <span class="ubcRed sanukBlack">3,054,853</span>
              </p>
            </div>
            <div>
              <p>
                # Registered sound recordings:
                <span class="ubcRed sanukBlack">1,684,164</span>
              </p>
            </div>
            <div>
              <p>
                # Registered cue sheets:
                <span class="ubcRed sanukBlack">21,413</span>
              </p>
            </div>
            <div>
              <p>
                # Direct UBC members:
                <span class="ubcRed sanukBlack">71,027</span>
              </p>
            </div>
            <div>
              <p>
                # UBC employees:
                <span class="ubcRed sanukBlack">125</span>
              </p>
            </div>
            
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "OsNumeros2025",
  props: ["clicked"],

  data() {
    return {
      setaScrollState: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#numeros2025");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.numerosBox {
  margin-top: 12px;
}

.numerosBox p {
  margin: 0;
  font-size: 16px !important;
}

.numerosBox span {
  font-size: 24px;
}

.titleDireitos {
  font-size: 16px;
}

@media screen and (max-width: 800px) {
  .topMob32 {
    margin-top: 32px;
  }
}
</style>
